'use strict';

angular.module('mean.bids').controller('BidRequestEditController', ['$scope', 'userService', 'MeanUser', 'Global', 'Bids', '$filter', '$sce', 'toaster', 'NotifyService', 'BidRequestEdit', 'CompanyFactors', '$location', 'Materials', 'Equipments', 'BidMaterialsSaves', 'tradeCodeService', 'taskTotalsService',
  function($scope, userService, MeanUser, Global, Bids, $filter, $sce, toaster, NotifyService, BidRequestEdit, CompanyFactors, $location, Materials, Equipments, BidMaterialsSaves, tradeCodeService, taskTotalsService) {
    $scope.global = Global;

    $scope.user = MeanUser.user;

    $scope.expanded_table = 'true';
    $scope.bid_total_labor = 0;
    $scope.bid_total_materials = 0;
    $scope.bid_total_equipment = 0;
    $scope.bid_total = 0;
    $scope.bid_general_liability = 0;
    $scope.available_materials = [];
    $scope.available_categories = [];
    $scope.available_equipments = [];
    $scope.available_equipment_categories = [];
    $scope.available_tasks = [];
    $scope.bid_menu = [];
    $scope.my_inclusions = [];
    $scope.my_exclusions = [];
    $scope.materialEditId = 0;
    $scope.equipmentEditId = 0;

    $scope.editSpecText = '';
    $scope.editSpecHeader = '';
    $scope.editSpecIndex = 0;
    $scope.main_account = null;

    var data = [];

    $scope.viewDetails = function(type, index, text) {
        //this function gets called when the spec modal is active
        //and sets some global variables for the edit functions
        $scope.editSpecIndex = index;
        if(type) {
            $scope.editSpecHeader = 'Inclusion Edit';
        } else {
            $scope.editSpecHeader = 'Exclusion Edit';
        }

        $scope.editSpecText = text;
    };

    $scope.isMatOrEq = function() {
        if(!$scope.current_plan) return false;

        return $scope.current_plan.item === 'Materials' || $scope.current_plan.item === 'Equipment'
    };

    $scope.acceptEditSpec = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                if($scope.editSpecHeader === 'Inclusion Edit') {
                    bidder.inclusions[$scope.editSpecIndex] = $scope.editSpecText;
                    $scope.my_inclusions = bidder.inclusions;
                } else {
                    bidder.exclusions[$scope.editSpecIndex] = $scope.editSpecText;
                    $scope.my_exclusions = bidder.exclusions;
                }

                $scope.bid.$update();
            }
        });
    };

    $scope.cancelEditSpec = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                if($scope.editSpecHeader === 'Inclusion Edit') {
                    $scope.my_inclusions = bidder.inclusions;
                } else {
                    $scope.my_exclusions = bidder.exclusions;
                }
            }
        });
    };

    $scope.deleteSpec = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                if($scope.editSpecHeader === 'Inclusion Edit') {
                    bidder.inclusions.splice($scope.editSpecIndex, 1);
                    $scope.my_inclusions = bidder.inclusions;
                } else {
                    bidder.exclusions.splice($scope.editSpecIndex, 1);
                    $scope.my_exclusions = bidder.exclusions;
                }
                $scope.bid.$update();
            }
        });
    };

    $scope.addInclusion = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                bidder.inclusions.push($scope.newInclusion);
                $scope.my_inclusions = bidder.inclusions;
                $scope.bid.$update();
            }
        });

        $scope.newInclusion = '';
    };

    $scope.addExclusion = function() {
        $scope.bid.bidding_trades.forEach(function(bidder, ii){
            if($scope.getTradeCode(bidder.trade) === $scope.my_bid_trade) {
                bidder.exclusions.push($scope.newExclusion);
                $scope.my_exclusions = bidder.exclusions;
                $scope.bid.$update();
            }
        });

        $scope.newExclusion = '';
    };

    $scope.toggleTableColumns = function() {
        if($scope.expanded_table === 'true') {
            $scope.expanded_table = 'false';
        } else {
            $scope.expanded_table = 'true';
        }
    };

    $scope.init = function() {
        $scope.expanded_table = 'false';
    	$scope.bid = BidRequestEdit.get();

        if(!$scope.bid || !$scope.bid._id){
            $location.path('home');
            return;
        }

        // if(!$scope.bid) {
        //     $location.path('home');
        // }

        $scope.bid_menu.push({
            item: 'Materials'
        });

        $scope.bid_menu.push({
            item: 'Equipment'
        });

    	var menu = $scope.bid.project_plan;

        _.each($scope.bid.plan_codes, function(plan_code) {
            $scope.bid_menu.push({
                item: plan_code.code
            });
        });

        $scope.bid_menu.push({
            item: 'Cover'
        });

        $scope.bid_menu.push({
            item: 'Specs'
        });

        $scope.current_plan = $scope.bid_menu[0];
        $scope.main_bid_menu = $scope.bid_menu;

    	var bid_tasks = [];

    	var user = MeanUser.user;
        $scope.my_bid_trade = $scope.getTradeCode(user.trade[0]);
        var my_bid = $filter('filter')($scope.bid.bidding_trades, { trade: user.trade[0] }, true);

        if(my_bid.length !== 1){
            alert('There is more than one ' + user.trade[0] + ' in the bidding trades!  Contact Admin!');
        }

        $scope.my_inclusions = my_bid[0].inclusions;
        $scope.my_exclusions = my_bid[0].exclusions;

        $scope.material_supplier = my_bid[0].supplier;
        $scope.equipment_supplier = my_bid[0].equipment_supplier;

        userService.getMainAccount($scope.user.username).then((user) => {
            $scope.main_account = user;
            Materials.query({
                trade: $scope.my_bid_trade , 
                supplier: my_bid[0].supplier,
                userId: $scope.main_account._id
            }, function(materials) {
                $scope.available_materials = materials;
                $scope.available_materials.forEach(function(material, idx) {

                    var in_list = $filter('filter')($scope.available_categories, {name: material.category}, true);
                    if(in_list.length === 0) {
                        $scope.available_categories.push({
                            name: material.category
                        });
                    }
                });
            });
        });

        Equipments.query({ trade: $scope.my_bid_trade , supplier: my_bid[0].equipment_supplier}, function(equipments) {
            $scope.available_equipments = equipments;
            $scope.available_equipments.forEach(function(equipment, idx) {

                var in_list = $filter('filter')($scope.available_equipment_categories, {name: equipment.category}, true);
                if(in_list.length === 0) {
                    $scope.available_equipment_categories.push({
                        name: equipment.category
                    });
                }
            });
        });

        $scope.available_tasks = $filter('filter')($scope.bid.task_list, {trade: $scope.my_bid_trade},true);

        CompanyFactors.query({'trade_name': $scope.user.trade[0]}, function(company_factors) {
            company_factors.forEach(function(company_factor) {
                if(company_factor.trade_code === $scope.my_bid_trade) {

                    $scope.company_factors = company_factor;

                    $scope.applayCalculations(bid_tasks);
                }
            });
        });

    };

    $scope.supplierModalActivated = function(item_id) {
        $scope.override_task_id = item_id;

        if(!$scope.available_suppliers) {
            $scope.available_suppliers = [];

            Materials.query({
                trade: $scope.my_bid_trade,
                userId: $scope.main_account._id
             }, function(materials) {
                $scope.all_materials = materials;
                $scope.all_materials.forEach(function(material, idx) {

                    var in_list = $filter('filter')($scope.available_suppliers, {name: material.supplier}, true);
                    if(in_list.length === 0) {
                        $scope.available_suppliers.push({
                            name: material.supplier
                        });
                    }
                });
            });
        }
    };

    $scope.equipmentSupplierModalActivated = function(item_id) {
        $scope.override_task_id = item_id;

        if(!$scope.available_equipment_suppliers) {
            $scope.available_equipment_suppliers = [];

            Equipments.query({ trade: $scope.my_bid_trade }, function(equipments) {
                $scope.all_equipments = equipments;
                $scope.all_equipments.forEach(function(equipment, idx) {

                    var in_list = $filter('filter')($scope.available_equipment_suppliers, {name: equipment.supplier}, true);
                    if(in_list.length === 0) {
                        $scope.available_equipment_suppliers.push({
                            name: equipment.supplier
                        });
                    }
                });
            });
        }
    };

    $scope.onSupplierSelect = function() {
        $scope.overridden_materials = $filter('filter')($scope.all_materials, { supplier: $scope.new_supplier.name }, true);
        $scope.overridden_categories = [];

        $scope.overridden_materials.forEach(function(material, idx) {
            var in_list = $filter('filter')($scope.overridden_categories, {name: material.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_categories.push({
                    name: material.category
                });
            }
        });
    };

    $scope.onEquipmentSupplierSelect = function() {
        $scope.overridden_equipments = $filter('filter')($scope.all_equipments, { supplier: $scope.new_supplier.name }, true);
        $scope.overridden_equipment_categories = [];

        $scope.overridden_equipments.forEach(function(equipment, idx) {
            var in_list = $filter('filter')($scope.overridden_equipment_categories, {name: equipment.category}, true);
            if(in_list.length === 0) {
                $scope.overridden_equipment_categories.push({
                    name: equipment.category
                });
            }
        });
    };

    $scope.materialsPage = function() {
        var bid_tasks = [];

        if(!$scope.bid || !$scope.bid._id){
            return;
        }

        bid_tasks = $filter('filter')($scope.bid.task_list, {
            trade: $scope.my_bid_trade}, true);
    };

    $scope.equipmentsPage = function() {
        var bid_tasks = [];

        if(!$scope.bid || !$scope.bid._id){
            return;
        }

        bid_tasks = $filter('filter')($scope.bid.task_list, {
            trade: $scope.my_bid_trade}, true);
    };

    $scope.submitTradeBid = function() {
        var my_trade = $scope.getTradeString($scope.my_bid_trade);
        var me = $filter('filter')($scope.bid.bidding_trades, {trade: my_trade});
        if(me.length === 1) {
            me[0].submitted = 'true';

            var saved_items = new BidMaterialsSaves({
                user: MeanUser.user._id,
                name: $scope.bid.builder_name + ' - ' + $scope.bid.bid_name + ' - ' + $filter('date')(new Date(), 'ddMMMyyyy'),
                trade: my_trade,
                mtc_name: $scope.bid.mtc_name,
                mtc_code: $scope.bid.mtc_code,
                mtc_division: $scope.bid.mtc_division,
                supplier: me[0].supplier,
                inclusions: me[0].inclusions,
                exclusions: me[0].exclusions,
                task_list: $filter('filter')($scope.bid.task_list, {trade: $scope.my_bid_trade}, true),
                projectType:$scope.bid.projectType || 'Single Family',
                geoLocation:$scope.bid.geoLocation || 'Southern California'
            });

            saved_items.$save();

            //$scope.bid.$update();
            $location.path('home');
        } else {
            console.log('there are too many bidding trades here in submitTradeBid!!!');
        }
    };

    $scope.updateTablePlan = function() {
        var bid_tasks = [];

        //already know this users bid trade
        $scope.bid.task_list.forEach(function(task, index){
            if( task.trade === $scope.my_bid_trade){
                $scope.bid.bidding_trades.forEach(function(bidder, ii){
                    if($scope.getTradeCode(bidder.trade) === task.trade) {
                        //need to get bid_hours, quantities, etc... for each bid menu
                        //make sure the plan and task id's match up.
                        bidder.bid.forEach(function(bid, ii) {

                            if(bid.task_id === task._id) {
                                if(bid.plan_code === $scope.current_plan.item) {
                                    bid.equipment.forEach(function(eq, eidx) {
                                        task.equipment.forEach(function(teq, teidx) {
                                            if(eq.equipment_id === teq._id && teq._id) {
                                                teq.quantity = Number(eq.quantity);
                                                if(eq.price_per_order)
                                                  teq.price_per_order = Number(eq.price_per_order);
                                                if(eq.delivery_price)
                                                  teq.delivery_price = Number(eq.delivery_price);
                                            }
                                        });
                                    });
                                    bid.materials.forEach(function(mq, midx) {
                                        task.materials.forEach(function(tmq, tmidx) {
                                            if(mq.material_id === tmq._id && tmq._id) {
                                                tmq.quantity = Number(mq.quantity);
                                                if(mq.price_per_order)
                                                  tmq.price_per_order = Number(mq.price_per_order);
                                                if(mq.delivery_price)
                                                  tmq.delivery_price = Number(mq.delivery_price);
                                            }
                                        });
                                    });
                                    bid.subtasks.forEach(function(subtask, si) {
                                        task.subtasks.forEach(function(tsub, tsi) {
                                            if(subtask.task_id === tsub._id) {
                                                tsub.quantity = Number(subtask.quantity);
                                                tsub.bid_hours = Number(subtask.bid_hours);
                                                tsub.labor = Number(subtask.labor);
                                            }
                                        });
                                    });
                                } else {
                                    //this bid does not match the current plan but it matches the task.
                                    //we need to see if there is a plan/bid for this task.
                                    //if there is we need to leave it alone, if there is not
                                    //then we should clear it out.
                                    var bid_found = false;
                                    for(var i=0; i<bidder.bid.length; i=i+1){
                                        if(bidder.bid[i].task_id === task._id &&
                                            bidder.bid[i].plan_code === $scope.current_plan.item)
                                          bid_found = true;
                                    }

                                    if(!bid_found){
                                        task.equipment.forEach(function(mat){
                                            mat.quantity = 0;
                                        });
                                        task.materials.forEach(function(eq) {
                                            eq.quantity = 0;
                                            console.log('This might be the area with ' + eq);
                                        });
                                        task.subtasks.forEach(function(sub) {
                                            sub.quantity = 0;
                                            sub.bid_hours = 0;
                                        });
                                    }
                                }
                            }
                        });

                    }
                });

                bid_tasks.push(task);
            }
        });

        $scope.applayCalculations(bid_tasks);

        data = bid_tasks;

        $scope.bidTasksTableParams.reload();
    };

    $scope.currentNetPay = function(bid_hours, crew_rate, quantity, piece_rate) {
        var val = 0;

        if(bid_hours > 0) {
            val = bid_hours * crew_rate;
        } else {
            val = quantity * piece_rate;
        }

        return val;
    };

    $scope.directLaborCosts = function(bid_hours, quantity, ali_crew_rate) {
        var val = 0;
        if(bid_hours === 0) {
            val = quantity * ali_crew_rate;
        } else {
            val = bid_hours * ali_crew_rate;
        }

        return val;
    };

    $scope.aliCrewRate = function(bid_hours, piece_rate, crew_rate, ali_crew_net_pay) {
        var val = 0;

        if(bid_hours === 0) {
            val = piece_rate * ali_crew_net_pay;
        } else {
            val = crew_rate * ali_crew_net_pay;
        }

        return val;
    };

    $scope.aliCrewNetPay = function(direct_labor_costs, training_and_education) {
        return direct_labor_costs - training_and_education;
    };

    $scope.hoursAllowed = function(bid_hours, current_net_pay, crew_rate) {
        var temp_value = 0;

        if(!bid_hours) bid_hours = 0;
        if(!current_net_pay) current_net_pay = 0;
        if(!crew_rate) crew_rate = 0;

        if(bid_hours === 0) {
            if(crew_rate)
              temp_value = (current_net_pay / crew_rate);
            else
              temp_value = 0;
        } else {
            temp_value = bid_hours;
        }

        return $filter('number')(temp_value, 2);
    };

    $scope.trainingAndEducation = function(hours_allowed, training_and_education) {
        return hours_allowed * training_and_education;
    };

    $scope.employeeBenefits = function(hours_allowed, benefits) {
        return hours_allowed * benefits;
    };

    $scope.deleteMaterial = function(task_id, material, index){
        //remove material from the global task list
        var task_list = $filter('filter')($scope.bid.task_list, { _id: task_id}, true);

        if(task_list.length !== 1) {
            alert('There is a problem with the task_list size in deleteMaterial.  Call Admin.');
            return;
        }

        task_list[0].materials.splice(index, 1);

        //remove material from my bids
        //first get all of my bids
        var my_bid = $filter('filter')($scope.bid.bidding_trades, { trade: $scope.getTradeString($scope.my_bid_trade) }, true)[0];
        //now get all of my bids with this same task id
        var bids = $filter('filter')(my_bid.bid, {'task_id': task_id}, true);
        //go through each bids materials list and see if this current material is in it.
        //if so, then remove it
        bids.forEach(function(bid) {
            bid.materials.forEach(function(mat, idx) {
                if(mat.material_id === material._id) {
                    bid.materials.splice(idx, 1);
                }
            });
        });

        $scope.bid.$update();

        data = $filter('filter')($scope.bid.task_list, { trade: $scope.my_bid_trade}, true);

        $scope.bidMaterialsTableParams.reload();
    };

    $scope.addMaterial = function(task_id, material) {
        if(!material) {
            alert('No Material Selected!');
            return;
        }

        if(!material)

        var index;

        $scope.bid.task_list.forEach(function(bid, index) {
            if(bid._id === task_id){
                var time = new Date().getTime();

                var new_mat = ({
                    _id: time,
                    name: material.name,
                    supplier: material.supplier,
                    description: material.description,
                    unit: material.unit.unit,
                    trade: material.trade,
                    note: material.note,
                    units_per_order: Number(material.units_per_order),
                    price_per_order: material.price_per_order,
                    piece_per_size: material.piece_per_size,
                    delivery_price: material.delivery_price,
                    delivery_offset: material.delivery_offset,
                    isInventory:material.isInventory || false
                });

                bid.materials.push(new_mat);
            }
        });

        $scope.bid.$update();

        data = $filter('filter')($scope.bid.task_list, { trade: $scope.my_bid_trade}, true);

        $scope.bidMaterialsTableParams.reload();

        this.current_material = this.current_category = '';
        if(this.current_material)
          this.current_material.note = '';

        this.new_supplier = this.new_category = this.new_material = '';
    };

    $scope.deleteEquipment = function(task_id, equipment, index){
        //remove equipment from the global task list
        var task_list = $filter('filter')($scope.bid.task_list, { _id: task_id}, true);

        if(task_list.length !== 1) {
            alert('There is a problem with the task_list size in deleteEquipment.  Call Admin.');
            return;
        }

        task_list[0].equipment.splice(index, 1);

        //remove material from my bids
        //first get all of my bids
        var my_bid = $filter('filter')($scope.bid.bidding_trades, { trade: $scope.getTradeString($scope.my_bid_trade) }, true)[0];
        //now get all of my bids with this same task id
        var bids = $filter('filter')(my_bid.bid, {'task_id': task_id}, true);
        //go through each bids materials list and see if this current material is in it.
        //if so, then remove it
        bids.forEach(function(bid) {
            bid.equipment.forEach(function(eq, idx) {
                if(eq.equipment_id === equipment._id) {
                    bid.equipment.splice(idx, 1);
                }
            });
        });

        $scope.bid.$update();

        data = $filter('filter')($scope.bid.task_list, { trade: $scope.my_bid_trade}, true);

        $scope.bidEquipmentsTableParams.reload();
    };

    $scope.addEquipment = function(task_id, equipment) {
        if(!equipment) {
            alert('No Equipment Selected!');
            return;
        }

        var index;

        $scope.bid.task_list.forEach(function(bid, index) {
            if(bid._id === task_id){
                var time = new Date().getTime();

                var new_eq = ({
                    _id: time,
                    name: equipment.name,
                    supplier: equipment.supplier,
                    description: equipment.description,
                    unit: equipment.unit.unit,
                    trade: equipment.trade,
                    note: equipment.note,
                    units_per_order: Number(equipment.units_per_order),
                    price_per_order: equipment.price_per_order,
                    piece_per_size: equipment.piece_per_size,
                    delivery_price: equipment.delivery_price,
                    delivery_offset: equipment.delivery_offset
                });

                bid.equipment.push(new_eq);
            }
        });

        $scope.bid.$update();

        data = $filter('filter')($scope.bid.task_list, { trade: $scope.my_bid_trade}, true);

        $scope.bidEquipmentsTableParams.reload();

        this.current_equipment = this.current_category = '';
        if(this.current_equipment)
          this.current_equipment.note = '';

        this.new_supplier = this.new_category = this.new_equipment = '';
    };

    $scope.applayCalculations = function(tasks) {
        taskTotalsService.getCalculations(tasks, $scope.company_factors);

        $scope.bid_total = tasks.bid_total;
        $scope.bid_general_liability = tasks.bid_total_labor * $scope.company_factors.general_liability;
        $scope.bid_general_liability += tasks.bid_total_materials * $scope.company_factors.general_liability;
        $scope.bid_general_liability += tasks.bid_total_equipment * $scope.company_factors.general_liability;
        $scope.bid_total_labor = tasks.bid_total_labor;
        $scope.bid_total_materials = tasks.bid_total_materials;
        $scope.bid_total_equipment = tasks.bid_total_equipment;
        $scope.bid_direct_labor = tasks.bid_direct_labor;
        $scope.bid_workers_comp = tasks.bid_workers_comp;
        $scope.bid_payroll_taxes = tasks.bid_payroll_taxes;
        $scope.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
        $scope.bid_total_hours_allowed = tasks.bid_total_hours_allowed;

        $scope.bid_menu.forEach(function(bid) {
            if($scope.current_plan.item === bid.item) {
                if(bid.item !== 'Cover') {
                    console.log('found the current item ' + bid.item);
                    bid.bid_total = tasks.bid_total;
                    bid.bid_direct_labor = tasks.bid_direct_labor;
                    bid.bid_total_labor = tasks.bid_total_labor;
                    bid.bid_total_materials = tasks.bid_total_materials;
                    bid.bid_total_equipment = tasks.bid_total_equipment;
                    bid.bid_general_liability = tasks.bid_general_liability;
                    bid.bid_workers_comp = tasks.bid_workers_comp;
                    bid.bid_payroll_taxes = tasks.bid_payroll_taxes;
                    bid.bid_overhead_and_profit = tasks.bid_overhead_and_profit;
                    bid.bid_total_hours_allowed = tasks.bid_total_hours_allowed;
                }
            }
        });
    };

    $scope.buildBidCoverPage = function() {
        $scope.bid_menu.forEach(function(bid) {
            if(bid.item !== 'Specs') {
                $scope.current_plan = bid;
                $scope.updateTablePlan();
            }
        });
    };

    $scope.filterItems = ['Materials', 'Equipment', 'Specs'];

    $scope.filterMenuItems = function(val) {
        return ($scope.filterItems.indexOf(val.item) === -1);
    };

    $scope.onSelect = function(item) {
        console.log('in the onSelect function ' + item.item);
        $scope.current_plan = item;
        if($scope.current_plan.item === 'Cover') {
            data = [];
            $scope.buildBidCoverPage();
        } else if($scope.current_plan.item === 'Materials') {
            data = [];
        } else if($scope.current_plan.item === 'Equipment') {
            data = [];
        } else if($scope.current_plan.item === 'Specs') {
            data = [];
        } else {
            $scope.updateTablePlan();
        }
    };

    $scope.setTaskEditId =  function(pid) {
        $scope.taskEditId = pid;
    };

    $scope.setMaterialEditId =  function(pid) {
        $scope.materialEditId = pid;
    };

    $scope.setEquipmentEditId =  function(pid) {
        $scope.equipmentEditId = pid;
    };

    $scope.next =  function(item) {
        //pid -1 is the index of the current task so lets just start with the next task and iterate
        $scope.update(item);
        var current_task_idx = item._id;
        for(; current_task_idx < $scope.bid.task_list.length; current_task_idx = current_task_idx + 1) {
            if($scope.bid.task_list[current_task_idx].trade === $scope.my_bid_trade) {
                $scope.taskEditId = $scope.bid.task_list[current_task_idx]._id;
                break;
            }
        }
    };

    $scope.updateMaterial = function(bid, material) {
        var task = $filter('filter')($scope.bid.task_list, {_id: bid._id}, true);
        if(task.length > 1) {
            alert('Too many task items returned in updateMaterial.  Call admin.');
            return;
        }
        var mat = $filter('filter')(task[0].materials, {_id: material._id}, true);
        if(mat.length > 1) {
            alert('Too many material items returned in updateMaterial.  Call admin');
        }

        //update the task_list array so new bids will have the good stuff
        mat[0].price_per_order = material.price_per_order;
        mat[0].note = material.note;

        var my_bid = $filter('filter')($scope.bid.bidding_trades, {trade: $scope.getTradeString($scope.my_bid_trade)});

        if(my_bid.length !== 1){
            alert('There is more than one ' + user.trade[0] + ' trade in updateMaterial!  Contact Admin!');
        }

        var my_tasks = $filter('filter')(my_bid[0].bid, {task_id: bid._id}, true);
        my_tasks.forEach(function(task) {
            var my_mat = $filter('filter')(task.materials, {material_id: material._id}, true);
            my_mat.forEach(function(matty) {
                matty.price_per_order = material.price_per_order;
                matty.note = material.note;
            })
        });

        $scope.bid.$update();
        $scope.materialEditId = -1;
    };

    $scope.updateEquipment = function(bid, equipment) {
        var task = $filter('filter')($scope.bid.task_list, {_id: bid._id}, true);
        if(task.length > 1) {
            alert('Too many task items returned in updateEquipment.  Call admin.');
            return;
        }
        var eq = $filter('filter')(task[0].equipment, {_id: equipment._id}, true);
        if(eq.length > 1) {
            alert('Too many equipment items returned in updateEquipment.  Call admin');
        }

        //update the task_list array so new bids will have the good stuff
        eq[0].price_per_order = equipment.price_per_order;
        eq[0].note = equipment.note;

        var my_bid = $filter('filter')($scope.bid.bidding_trades, {trade: $scope.getTradeString($scope.my_bid_trade)});

        if(my_bid.length !== 1){
            alert('There is more than one ' + user.trade[0] + ' trade in updateEquipment!  Contact Admin!');
        }

        var my_tasks = $filter('filter')(my_bid[0].bid, {task_id: bid._id}, true);
        my_tasks.forEach(function(task) {
            var my_eq = $filter('filter')(task.equipment, {equipment_id: equipment._id}, true);
            my_eq.forEach(function(eqs) {
                eqs.price_per_order = equipment.price_per_order;
                eqs.note = equipment.note;
            })
        });

        $scope.bid.$update();
        $scope.equipmentEditId = -1;
    };

    $scope.update = function(item) {
        // we have an item to update.  look through the bidding trades to get the owner
        $scope.bid.bidding_trades.forEach(function(trade, index){
            if($scope.getTradeCode(trade.trade) === $scope.my_bid_trade) {
                //found the owner of the bid
                //see if this task is in his bid list
                var updated = false;
                trade.bid.forEach(function(bid, bi) {
                    if(bid.task_id === item._id){
                        if(bid.plan_code === $scope.current_plan.item) {
                            //found the task.  update with new info
                            updated = true;
                            bid.labor = item.labor;

                            bid.materials = [];
                            item.materials.forEach(function(tmat,tmi) {
                                bid.materials.push({
                                    material_id: tmat._id,
                                    quantity: Number(tmat.quantity),
                                    price_per_order: Number(tmat.price_per_order),
                                    delivery_price: Number(tmat.delivery_price),
                                });
                            });

                            bid.equipment = [];
                            item.equipment.forEach(function(teqt, tei) {
                                bid.equipment.push({
                                    equipment_id: teqt._id,
                                    quantity: Number(teqt.quantity),
                                    price_per_order: Number(teqt.price_per_order),
                                    delivery_price: Number(teqt.delivery_price)
                                });
                            });

                            bid.subtasks = [];
                            item.subtasks.forEach(function(tsub, tsi) {
                                bid.subtasks.push({
                                    task_id: tsub._id,
                                    quantity: Number(tsub.quantity),
                                    bid_hours: Number(tsub.bid_hours),
                                    labor: Number(tsub.labor)
                                });
                            });
                        }
                    }
                });

                if(!updated) {
                    //the item to be updated was not found in the bidders list
                    trade.bid.push({
                        plan_code: $scope.current_plan.item,
                        task_id: item._id,
                        labor: item.labor,
                        materials: [],
                        equipment: [],
                        subtasks: []
                    });

                    if(item.materials.length) {
                        item.materials.forEach(function(mat, mi) {
                            trade.bid[trade.bid.length - 1].materials.push({
                                material_id: mat._id,
                                quantity: Number(mat.quantity),
                                price_per_order: Number(mat.price_per_order),
                                delivery_price: Number(mat.delivery_price)
                            });
                        });
                    }
                    if(item.equipment.length) {
                        item.equipment.forEach(function(mat, mi) {
                            trade.bid[trade.bid.length - 1].equipment.push({
                                equipment_id: mat._id,
                                quantity: Number(mat.quantity),
                                price_per_order: Number(mat.price_per_order),
                                delivery_price: Number(mat.delivery_price)
                            });
                        });
                    }
                    if(item.subtasks.length) {
                        item.subtasks.forEach(function(sub, si) {
                            trade.bid[trade.bid.length - 1].subtasks.push({
                                task_id: sub._id,
                                quantity: Number(sub.quantity),
                                bid_hours: Number(sub.bid_hours),
                                labor: Number(sub.labor)
                            });
                        });
                    }
                }

                $scope.bid.$update();

                $scope.updateTablePlan();
            }
        });
    };

    $scope.copyPlanData = function(from_plan, to_plan) {
        if(!from_plan || from_plan.item === 'Materials') {
            alert('No From Plan Selected for Copying');
            return;
        }
        if(!to_plan || to_plan.item === 'Materials') {
            alert('No To Plan Selected for Copying');
            return;
        }
        if(!from_plan || from_plan.item === 'Equipment') {
            alert('No From Plan Selected for Copying');
            return;
        }
        if(!to_plan || to_plan.item === 'Equipment') {
            alert('No To Plan Selected for Copying');
            return;
        }
        to_plan.bid_direct_labor = from_plan.bid_direct_labor;
        to_plan.bid_general_liability = from_plan.bid_general_liability;
        to_plan.bid_overhead_and_profit = from_plan.bid_overhead_and_profit;
        to_plan.bid_payroll_taxes = from_plan.bid_payroll_taxes;
        to_plan.bid_total = from_plan.bid_total;
        to_plan.bid_total_equipment = from_plan.bid_total_equipment;
        to_plan.bid_total_hours_allowed = from_plan.bid_total_hours_allowed;
        to_plan.bid_total_labor = from_plan.bid_total_labor;
        to_plan.bid_total_materials = from_plan.bid_total_materials;
        to_plan.bid_workers_comp = from_plan.bid_workers_comp;

        $scope.bid.bidding_trades.forEach(function(trade_bid, idx) {
            if($scope.getTradeCode(trade_bid.trade) === $scope.my_bid_trade) {
                //found my trade bid list erase all entries for to_plan
                trade_bid.bid = $filter('filter')(trade_bid.bid, {plan_code: '!'+to_plan.item}, true);

                var temp_list = [];
                //now add the plan entries
                trade_bid.bid.forEach(function(bid) {
                    if(bid.plan_code === from_plan.item) {
                        var temp_bid = {};
                        angular.copy(bid, temp_bid);
                        delete temp_bid._id;
                        var idx = temp_list.push(temp_bid) - 1;
                        temp_list[idx].plan_code = to_plan.item;
                    }
                });

                temp_list.forEach(function(add) {
                    trade_bid.bid.push(add);
                });
            }
        });

        $scope.bid.$update();

        $scope.updateTablePlan();
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };

    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };
  }
]);


// WEBPACK FOOTER //
// ./packages/custom/bids/public/controllers/bidrequestedit.js